import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-error-handling',
  templateUrl: './error-handling.component.html',
  styleUrls: ['./error-handling.component.scss']
})
export class ErrorHandlingComponent implements OnInit {

  @Input() errorMessage: string;

  constructor() {}

  ngOnInit() {}

}